import { initPipelineDetails } from '../../../../ci/pipeline_details/pipeline_details_bundle.js?vue3';

initPipelineDetails();
